import { Avatar, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { AppColors } from '../../../Utils/helper/AppColors';
import dashBoardBgImg from '../../../Assets/Image/dashEmpty.svg';
import { AddIcon } from '../../../Components/Icons/Icons';
import { PATH_NAME } from '../../../Routes/Pathname';
import { useNavigate } from 'react-router-dom';

const DashboardEmptyView = ({ setOpen }) => {
	const navigate = useNavigate();

	return (
		<Stack
			height="calc(100vh - 100px)" // Adjust height to account for the PageHeading or other elements
			alignItems="center"
			justifyContent="center"
			borderRadius={'15px'} // chages as per figma
			bgcolor={AppColors.WHITE}
			gap={1}
			mt={2}
		>
			<Avatar src={dashBoardBgImg} sx={{ width: 400, height: 400, borderRadius: 1 }} alt="No Data Available" />
			<Typography
				px={{ xs: 2, sm: 10, md: 40 }}
				textAlign="center"
				fontWeight={400}
				fontSize={14}
				lineHeight={'150%'}
				fontFamily={'Poppins'}
				color={AppColors.TEXT_SECONDARY}
			>
				Your dashboard is currently empty because no campaigns have been created. Once you launch your first campaign, you’ll
				start seeing real-time data, charts, and insights here.
			</Typography>

			<Button
				onClick={() => navigate(PATH_NAME.CAMPAIGN_EDIT, { state: { fromDashboard: true } })}
				variant="contained"
				color='info'
				startIcon={<AddIcon color={AppColors.WHITE} />}
				 
			>
				Create Campaign
			</Button>
		</Stack>
	);
};

export default DashboardEmptyView;
